import {
  ConfigurationPageConnectivity,
  ConfigurationPageType,
} from "../interfaces";

export const SETUP_CONNECTIVITY: ConfigurationPageConnectivity = {
  type: ConfigurationPageType.CONNECTIVITY,
  label: "CONNECTIVITY",
  menuLabel: "CONNECTIVITY",
  name: "setup_connectivity",
  path: "connectivity",
  description: "CONF_DESC_SETUP_CONNECTIVITY",
  isStaff: true,
  hideInMenu: true,
  model: {
    entityName: "name",
    label: "CONNECTIVITY",
    path: "",
    name: "Connectivity",
    attributes: [],
    filters: [],
  },
};
